<template>
  <v-container id="analyse">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <app-city-combobox :filter="filter"></app-city-combobox>
      </v-col>

      <v-col>
        <app-group-solution-combobox
          :filter="filter"
          v-if="
            isFullAdmin ||
            (config.podeAnalisarRelatorio && groupsConfig.podeAnalisarRelatorio)
          "
        ></app-group-solution-combobox>
      </v-col>

      <v-col>
        <app-consultant-combobox
          :filter="filter"
          v-if="
            isFullAdmin ||
            (config.podeAnalisarRelatorio && groupsConfig.podeAnalisarRelatorio)
          "
        ></app-consultant-combobox>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataInicialString"
          v-mask="'##/##/####'"
          label="Data Inicial"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataFinalString"
          v-mask="'##/##/####'"
          label="Data Final"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-select
          v-model="filter.statusRelatorioId"
          item-text="text"
          item-name="value"
          :items="statusRelatorios"
          label="Status dos Relatórios"
        >
        </v-select>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="loadReportsNovo()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="reports"
          item-key="relatorioId"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="props">
            <tr
              :class="{
                evidenciada:
                  props.item.statusRelatorioId === 2 ||
                  props.item.statusRelatorioId === 4,
                evidenciar: props.item.statusRelatorioId === 3,
                rejeitada: props.item.statusRelatorioId === 1,
              }"
            >
              <td @click="clickRow(props.item)">
                {{ props.item.relatorioId }}
              </td>
              <td @click="clickRow(props.item)">{{ props.item.usuario }}</td>
              <td @click="clickRow(props.item)">{{ props.item.municipio }}</td>
              <td :title="props.item.motivoRejeicao">
                <template
                  v-if="
                    props.item.statusRelatorioId === 3 &&
                    (isFullAdmin ||
                      (config.podeAnalisarRelatorio &&
                        groupsConfig.podeAnalisarRelatorio) ||
                      props.item.usuarioId === user.usuarioId)
                  "
                >
                  {{ transformValue(props.item.motivoRejeicao) }}
                </template>
              </td>
              <td @click="clickRow(props.item)">
                <span
                  v-if="props.item.grupoSolucao && props.item.grupoSolucao != 0"
                  >{{ props.item.grupoSolucao }}</span
                >
                <span v-else>-</span>
              </td>
              <td @click="clickRow(props.item)">
                <span v-if="props.item.solucao && props.item.solucao != 0">{{
                  props.item.solucao
                }}</span>
                <span v-else>-</span>
              </td>
              <td @click="clickRow(props.item)">
                <span
                  v-if="
                    props.item.tarefasString && props.item.tarefasString != 0
                  "
                  >{{ props.item.tarefasString }}</span
                >
                <span v-else>-</span>
              </td>
              <td @click="clickRow(props.item)">
                {{ props.item.fim | moment("DD/MM/YYYY") }}
              </td>
              <td @click="clickRow(props.item)">
                {{ props.item.criacao | moment("DD/MM/YYYY") }}
              </td>
              <td v-if="estado === 'SP'" align="center">
                <template
                  v-if="
                    props.item.tarefasString &&
                    props.item.tarefasString.includes('PESQUISA DE REAÇÃO')
                  "
                >
                  <a @click="reenviarPesquisa(props.item.relatorioId)"
                    >Reenviar Pesquisa</a
                  >
                </template>
                <br />
                <br />
                <template
                  v-if="
                    props.item.tarefasString &&
                    props.item.tarefasString.includes('PESQUISA DE REAÇÃO')
                  "
                >
                  <a
                    :href="
                      'http://pesquisa.sp.cidadeempreendedora.com.br/dashboard.php?idevento=' +
                      props.item.encontroId
                    "
                    target="_blank"
                    >Ver consolidação</a
                  >
                </template>
              </td>
              <td>
                <app-modal-delete
                  v-if="
                    (isFullAdmin ||
                      (config.podeAnalisarRelatorio &&
                        groupsConfig.podeAnalisarRelatorio &&
                        props.item.statusRelatorioId !== 2) ||
                      (config.podeExcluirRelatorio &&
                        groupsConfig.podeExcluirRelatorio &&
                        props.item.statusRelatorioId !== 2)) &&
                    props.item.statusRelatorioId !== 4
                  "
                  :relatorio="props.item"
                  @onDelete="loadReportsNovo"
                >
                  <template v-slot:title> Deletar Relatório </template>
                </app-modal-delete>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span> Nenhum relatório retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <app-modal-analyse-report
      :dialog="openModal"
      :id="selectedReport.relatorioId"
      @onCloseReport="onCloseModal"
      v-if="
        isFullAdmin ||
        (config.podeAnalisarRelatorio && groupsConfig.podeAnalisarRelatorio)
      "
    >
    </app-modal-analyse-report>

    <app-modal-confirm-finish-solution
      :dialog="modalConfirmFinishSolution"
      :solutions="solutions"
      @onCloseModal="loadReportsNovo"
      v-if="
        isFullAdmin ||
        (config.podeAnalisarRelatorio && groupsConfig.podeAnalisarRelatorio)
      "
    >
    </app-modal-confirm-finish-solution>
  </v-container>
</template>

<script>
import { reportAPI } from "@/modules/report";
import { citySolutionAPI } from "@/modules/city/API/CitySolutionAPI";
import { mapActions, mapGetters } from "vuex";
import { AppConsultantCombobox } from "@/modules/user";
import { AppGroupSolutionCombobox } from "@/modules/group-solution";
import { AppCityCombobox } from "@/modules/city";
import AppModalAnalyseReport from "./ModalAnalyse";
import AppModalConfirmFinishSolution from "@/modules/solution/components/city/ModalConfirmFinishSolution";
import AppModalDelete from "./../components/ModalDelete";

export default {
  components: {
    AppCityCombobox,
    AppConsultantCombobox,
    AppModalAnalyseReport,
    AppGroupSolutionCombobox,
    AppModalConfirmFinishSolution,
    AppModalDelete,
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "user",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isFullAdmin",
      "isAT",
      "isGov",
    ]),
  },
  data() {
    return {
      estado: this.$store.state.uf,
      headers: [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Usuário",
          value: "usuario",
        },
        {
          text: "Município",
          value: "municipio",
        },

        {
          text: "Motivo da Rejeição",
          value: "motivoRejeicao",
        },
        {
          text: "Grupo de Solução",
          value: "grupoSolucao",
        },
        {
          text: "Solução",
          value: "solucao",
        },
        {
          text: "Tarefas",
          value: "tarefasString",
        },
        {
          text: "Data fim do Encontro",
          value: "fim",
        },
        {
          text: "Criação",
          value: "criacao",
        },
      ],
      reports: [],
      filter: {
        statusRelatorioId: 1,
        municipioId: null,
      },
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),

      selectedReport: {},
      openModal: false,
      solutions: [],
      modalConfirmFinishSolution: false,
      statusRelatorios: [
        { text: "Não Analisado", value: 1 },
        { text: "Aprovado", value: 2 },
        { text: "Inserido em Processo de Pagamento", value: 4 },
        { text: "Reprovado", value: 3 },
        { text: "Todos", value: null },
      ],
      breadcrumbs: [
        {
          text: "Home",
          disabled: false,
          href: "cidade",
        },
        {
          text: "Análise de Relatórios",
          disabled: true,
          href: "analisar-relatorios",
        },
      ],
    };
  },
  mounted() {
    // this.loadReports()
    if (this.isAT) {
      this.headers = [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Usuário",
          value: "usuario",
        },
        {
          text: "Município",
          value: "municipio",
        },

        {
          text: "Motivo da Rejeição",
          value: "motivoRejeicao",
        },
        {
          text: "Grupo de Iniciativas",
          value: "grupoSolucao",
        },
        {
          text: "Iniciativas",
          value: "solucao",
        },
        {
          text: "Atividades",
          value: "tarefasString",
        },
        {
          text: "Data fim da Agenda",
          value: "fim",
        },
        {
          text: "Criação",
          value: "criacao",
        },
      ];
    }

    if (this.isGov) {
      this.headers = [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Usuário",
          value: "usuario",
        },
        {
          text: "Projeto",
          value: "municipio",
        },

        {
          text: "Motivo da Rejeição",
          value: "motivoRejeicao",
        },
        {
          text: "Grupo de Iniciativas",
          value: "grupoSolucao",
        },
        {
          text: "Iniciativas",
          value: "solucao",
        },
        {
          text: "Atividades",
          value: "tarefasString",
        },
        {
          text: "Data fim da Agenda",
          value: "fim",
        },
        {
          text: "Criação",
          value: "criacao",
        },
      ];
    }
    this.loadReportsNovo();
  },
  methods: {
    ...mapActions(["setLoading"]),
    transformValue(item) {
      if (item && item.length > 20) {
        return item.substring(0, 20) + "...";
      }

      return item;
    },
    loadReportsNovo() {
      this.openModal = false;
      this.modalConfirmFinishSolution = false;
      if (this.filter.municipio) {
        this.filter.municipioId = this.filter.municipio.municipioId;
      } else this.filter.municipioId = null;
      if (
        !this.isFullAdmin &&
        !this.config.podeAnalisarRelatorio &&
        !this.groupsConfig.podeAnalisarRelatorio
      )
        this.filter.usuarioId = this.user.usuarioId;
      this.setLoading(true);
      reportAPI
        .getByFilterNovo(this.filter)
        .then((resp) => {
          this.reports = resp.data;
          if (this.filter.grupoSolucaoId) {
            this.reports = this.reports.filter((i) => {
              return i.grupoSolucaoId === this.filter.grupoSolucaoId;
            });
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar relatórios");
        });
    },
    /*
    loadReports () {
      this.loadReportsNovo()
      this.openModal = false
      this.modalConfirmFinishSolution = false
      if (this.filter.municipio) {
        this.filter.municipioId = this.filter.municipio.municipioId
      }
      else this.filter.municipioId = null
      if (!this.isAdmin && !this.isSPFesp && !this.isSPFespEspecial && !this.isSPCoordenador) this.filter.usuarioId = this.user.usuarioId
      this.setLoading(true)
      reportAPI.getByFilter(this.filter)
        .then(resp => {
          this.reports = resp.data
          if (this.filter.grupoSolucaoId) {
            this.reports = this.reports.filter((i) => {
              return i.encontro.solucoes[0].municipioSolucao.municipioGrupoSolucao.grupoSolucaoId === this.filter.grupoSolucaoId
            })
          }
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao listar relatórios')
        })
    },
    */
    clickRow(data) {
      this.openModal = true;
      this.selectedReport = data;
    },
    removerRelarotioAnalitico(relatorio) {
      reportAPI
        .delete(relatorio.item.relatorioId)
        .then((resp) => {
          this.loadReportsNovo();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao excluir relatorio analitico");
        });
    },
    reenviarPesquisa(relatorioId) {
      this.setLoading(true);
      var relatorioIdString = "";
      relatorioIdString = relatorioIdString + relatorioId;
      reportAPI
        .reenviarPesquisa(relatorioIdString)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Pesquisa reenviada");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao reenviar pesquisa");
        });
    },
    onCloseModal(report) {
      if (report && report.statusRelatorioId === 2) {
        this.openModal = false;
        citySolutionAPI
          .getReadyToFinish(report.municipioId)
          .then((resp) => {
            this.solutions = resp.data;
            this.loadReportsNovo();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error(
              `Erro ao listar ${
                this.isAT ? "iniciativas" : "soluções"
              } a finalizar`
            );
          });
      } else {
        this.loadReportsNovo();
      }
    },
  },
};
</script>
